import React, { useState, useMemo } from "react";
import "./TermsandConditions.scss";
import { Button } from "reactstrap";
import getDataFromApi from "./getDataFromApi";

import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

// For most React apps, this is the safest setup
pdfjs.GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const TermsandConditions = ({
  showAccept = true,
  onClose,
  pdfUrl,
  title = "Terms and Conditions",
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [checked, setChecked] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(false);
  const [acceptError, setAcceptError] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [pdfError, setPdfError] = useState(null);

  const privacy_policy_version = localStorage.getItem("privacy_policy_version");

  const mockPolicyData = {
    version: "1.1",
    pdfUrl:
      pdfUrl ||
      (showAccept
        ? "/terms/terms-and-conditions.pdf"
        : "/terms/terms-and-conditions-in-login-page.pdf"),
  };

  const resolvedPdfUrl = useMemo(() => {
    return new URL(mockPolicyData.pdfUrl, window.location.origin).href;
  }, [mockPolicyData.pdfUrl]);

  const closeModal = () => {
    setIsOpen(false);
    if (onClose) onClose();
  };

  const handleAccept = async () => {
    if (!checked) return;

    setAcceptLoading(true);
    setAcceptError(null);

    try {
      await getDataFromApi(
        `${window["ENV"].API_URL}/authentication/accept-privacy-policy`,
        "POST",
        {
          privacy_policy_version,
        }
      );

      localStorage.setItem("privacy_policy_accepted", "true");
      closeModal();
    } catch (err) {
      console.error(err);
      setAcceptError(err.message || "Failed to accept privacy policy");
    } finally {
      setAcceptLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="terms-overlay">
      <div className="terms-modal">
        {!showAccept && (
          <button className="terms-close" onClick={closeModal}>
            ×
          </button>
        )}

        <div className="terms-content">
          <Document
            file={resolvedPdfUrl}
            onLoadSuccess={({ numPages }) => {
              setNumPages(numPages);
              setPdfError(null);
            }}
            onLoadError={(error) => {
              console.error("PDF load error:", error);
              console.error("PDF URL:", resolvedPdfUrl);
              setPdfError(error?.message || "Unable to load PDF.");
            }}
            loading={<div className="terms-loader">Loading document...</div>}
            error={
              <div className="terms-error">
                Unable to load PDF.
                <br />
                <small>{pdfError}</small>
              </div>
            }
          >
            {Array.from(new Array(numPages || 0), (_, index) => (
              <Page
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                width={Math.min(window.innerWidth - 60, 850)}
              />
            ))}
          </Document>
        </div>

        {showAccept && (
          <div className="terms-footer">
            <label className="terms-checkbox d-a gap-2">
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              <span className="" style={{paddingTop:'2px'}}>I have read and agree to the Terms &amp; Conditions</span>
            </label>

            <Button
              color="primary"
              disabled={!checked || acceptLoading}
              onClick={handleAccept}
            >
              {acceptLoading ? "Accepting..." : "Accept"}
            </Button>

            {acceptError && <p className="text-danger mt-2">{acceptError}</p>}
          </div>
        )}
      </div>
    </div>
  );
};

export default TermsandConditions;
